module.exports = {
	Personas: require( './Personas' ),
	Voices: require( './Voices' )
};
